import { useState, useEffect } from 'react';
import { inject } from 'mobx-react';
import { Col, Row } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter'
import MemberSearchList from '~/components/MemberSearchList/MemberSearchList.jsx';
import TimeBankList from './TimeBankList';

//elements
import LoadingSpinner from '../../../elements/LoadingSpinner.js';

const TimeBank = ({ timeBankStore, t, userStore }) => {
    const [timeBankMember, setTimeBankMember] = useState([]);
    const [currentMemberId, setCurrentMemberId] = useState(null);
    const currentUser = userStore?.currentUser;
    const isMember = currentUser.user_type === 'member';

    useEffect(() => {
        const loadData = async () => {
            let pmMembers = '';
            if (currentUser.user_type !== 'admin' && currentUser?.Manages?.length) {
                pmMembers = currentUser.Manages.join(',');
            }
            const members = await timeBankStore.loadTimeBankMember({ pmMembers });
            const currMem = timeBankStore?.filters?.currentUserTimeBankList ? members?.find(ele => ele?.id === timeBankStore?.filters?.currentUserTimeBankList) : members[0]
            setCurrentMemberId(currMem)
            setTimeBankMember(members);
            timeBankStore.setFilter('currentUserTimeBankList', currMem?.id)
        };
        loadData();
    }, []);

    const handleMemberList = (entity) => {
        setCurrentMemberId(entity)
        timeBankStore.setFilter('currentUserTimeBankList', entity.id)
        timeBankStore.onFilter();
    }

    const reloadTimebankBalance = async (id) => {
        let pmMembers = '';
        if (currentUser.user_type !== 'admin' && currentUser?.Manages?.length) {
            pmMembers = currentUser.Manages.join(',');
        }
        const members = await timeBankStore.loadTimeBankMember({ pmMembers });
        setTimeBankMember(members);
        timeBankMember.map(ele => {
            if (ele.id === id) {
                const currMem = timeBankStore?.filters?.currentUserTimeBankList ? members?.find(ele => ele?.id === timeBankStore?.filters?.currentUserTimeBankList) : members[0]
                setCurrentMemberId(currMem)
            }
        })
    }

    if (timeBankStore.loading) return <LoadingSpinner />;

    return (
        <Row className="border border-radius-10 mt-2" style={{ maxHeight: '120vh', minHeight: '70vh', height: '120vh', overflow: 'hidden' }}>
            {!isMember &&
                <Col xs={12} md={3} className='p-0 mb-3 mb-md-0'>
                    <MemberSearchList
                        members={timeBankMember}
                        selectedId={currentMemberId?.id}
                        onSelect={handleMemberList}
                    />
                </Col>
            }
            <Col xs={12} md={isMember ? 12 : 9}>
                {(currentMemberId?.id || isMember) ?
                    <TimeBankList
                        userDetails={currentMemberId}
                        reloadTimebankBalance={reloadTimebankBalance}
                    />
                    :
                    <div className='d-flex justify-content-center fw-600 align-items-center h-100'>{t('No data found')}</div>
                }
            </Col>
        </Row>
    );
};

export default inject('userStore', 'timeBankStore')(applicationRouter(withLocalization(TimeBank)));
